/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, warp-drive/no-legacy-request-patterns */
// Extends From
import Route from '@ember/routing/route';

// Ember Imports
import { service } from '@ember/service';
// External Imports
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class MyProfileRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    const personId = this.get('session.person.id');
    return hash({
      devices: this.store.query('device', {
        personId,
      }),
    });
  }
}
